module.exports = __webpack_public_path__ + "img/app7.4a4572ab.png";